import React, { useEffect } from 'react';
import { MailCheckConstants } from '../../MailCheckConstants';
import { getEndpoint, callApi, callPdfGeneration } from '../../../../utils/api';
import { convertAccountType } from '../../../../redux/modules/fundingTrackingData/fundingTrackingData.module';
import {
  SSJBeaconButton,
  SSJBeaconModal,
} from '../../../Shared/Beacon/Registry';
import printIcon from '../../../../assets/images/print-icon.svg';
import continueIcon from '../../../../assets/images/beacon-chevron-right.svg';
import { useSelector } from 'react-redux';
import retirementIcon from '../../../../assets/images/retirement-icon.svg';
import downloadIcon from '../../../../assets/images/download-icon.svg';
import './MailACheckPage.scss';
import config from '../../../../config/config';
import TRP from '../../../Shared/TRP/TRP';
import { isCustomerWebViewEnabled } from '../../../../redux/modules/authentication/authentication.module.selectors';
import { getPersonalInformationData } from '../../../../redux/modules/user/PersonalInformation/personalInformation.selectors';
import { dispatchPageLoad } from '../../../../redux/utils/analytics-helper';
import { pdfGeneration } from '../../../../utils/fundingMethod/fundingMethodUtils';

const MailACheckPage = () => {
  useEffect(() => {
    dispatchPageLoad('Mail Check');
  }, []);

  const userInformation = useSelector(getPersonalInformationData);
  const fundingTrackingDataStore = useSelector(
    (state) => state?.fundingTrackingData?.store
  );
  const customerWebViewEnabled = useSelector(isCustomerWebViewEnabled);
  const mailCheckValues = {
    accountType:
      fundingTrackingDataStore?.userAccountFundingData?.agreementType || '',
    accountNumber: fundingTrackingDataStore?.AccountAgreementNumber || '',
    accountOwners:
      fundingTrackingDataStore?.userAccountFundingData?.agreementParties || [],
  };

  const handleModalClick = (action) => {
    const modal = document.querySelector('#downloadInvesTryAgian');
    if (modal === null) {
      return;
    }
    //
    switch (action) {
      case 'TryAgain':
        modal.show();
        break;
      case 'Cancel':
        modal.close();
        break;
      default:
        break;
    }
  };

  const downloadCheck = async () => {
    const investmentSlipPayload = {
      accountType:
        fundingTrackingDataStore?.userAccountFundingData?.agreementType,
      customer: {
        firstName: userInformation?.firstName,
        lastName: userInformation?.lastName,
      },
      address: {
        street1: userInformation?.primaryAddress.street1,
        city: userInformation?.primaryAddress.city,
        state: userInformation?.primaryAddress.state,
        zip: userInformation?.primaryAddress.zip,
      },
      fundSelections: [
        {
          dollarAmount:
            fundingTrackingDataStore?.userAccountFundingData?.balanceAsOf,
          fundName: fundingTrackingDataStore?.userAccountFundingData?.fundName,
          accountNumber: mailCheckValues.accountNumber,
        },
      ],
    };
    const fundingActionPayload = {
      agreementKey: {
        '@Type': 'AgreementKey',
        agreementID: fundingTrackingDataStore?.AccountAgreementID,
        agreementNumber: mailCheckValues.accountNumber,
      },
      onboardingFundingAction: `CHECK_INITIATED`,
    };
    // using uniq pdf api
    try {
      const pdfResponse = await callPdfGeneration(
        getEndpoint('mailCheck'),
        { method: 'POST' },
        JSON.stringify(investmentSlipPayload)
      );
      await callApi(
        getEndpoint('fundingAction'),
        {
          method: 'PUT',
        },
        JSON.stringify(fundingActionPayload)
      );
      pdfGeneration(pdfResponse);
    } catch (err) {
      console.log('Error:', err);
      handleModalClick('TryAgain');
    }
  };

  const handleContinueBtn = () => {
    return (window.location.href = `${config.url}/usis/my-accounts/dashboard`);
  };

  return (
    <div className="mailCheck-wrapper">
      <div className="mailCheck-wrapper_header">
        <h2 className="mailCheck-wrapper_header_text">
          {MailCheckConstants.mailACheckPage.headerTitle}
        </h2>
        <div className="mailCheck-wrapper_header_print">
          <SSJBeaconButton
            id="printButton"
            label="Print"
            variant="tertiary"
            icon-align="left"
            onClick={() => {
              window.print();
            }}
          >
            <img
              slot="icon"
              icon-align="left"
              alt="Print Button"
              fill="none"
              className="mailCheck-wrapper_header_print_icon"
              height="18"
              width="18"
              src={printIcon}
            />
          </SSJBeaconButton>
        </div>
      </div>
      <p className="mailCheck-wrapper_desc">
        {MailCheckConstants.mailACheckPage.pageDesc}
      </p>
      <div className="mailCheck-wrapper_pointers">
        <div className="mailCheck-wrapper_pointers_step">
          <div className="mailCheck-wrapper_pointers_step_box">
            <p className="mailCheck-wrapper_pointers_step_text">
              {MailCheckConstants.mailACheckPage.stepTitle1}
            </p>
            <p className="mailCheck-wrapper_pointers_step_accType">
              <span>{convertAccountType(mailCheckValues?.accountType)}</span>
            </p>
            <p className="mailCheck-wrapper_pointers_step_accNo blocked_data">
              {mailCheckValues?.accountNumber}
              <span className="dot" />
              <span className="mailCheck-wrapper_pointers_step_accNo-user blocked_data">{`${mailCheckValues?.accountOwners[0]?.fullName}`}</span>
            </p>
            <SSJBeaconButton
              id="inv-slip-btn"
              className="submit-btn"
              label="Download Investment Slip"
              icon-align="left"
              variant="primary"
              scale="jumbo"
              onClick={downloadCheck}
              disabled={customerWebViewEnabled}
            >
              <img
                slot="icon"
                icon-align="left"
                alt="Download Slip Button"
                className="continue-arrow-icon"
                fill="none"
                height="16"
                width="16"
                src={downloadIcon}
              />
            </SSJBeaconButton>
          </div>
        </div>
        <div className="mailCheck-wrapper_pointers_step">
          <div className="mailCheck-wrapper_pointers_step_box">
            <p className="mailCheck-wrapper_pointers_step_text">
              {MailCheckConstants.mailACheckPage.stepTitle2}
            </p>
            <p className="mailCheck-wrapper_pointers_step_address">
              <TRP /> <br />
              P.O. Box 17300 <br />
              Baltimore, MD 21297-1300
            </p>
          </div>
        </div>
        <div className="mailCheck-wrapper_note">
          <div className="retirement-icon">
            <img src={retirementIcon} alt="retirement-icon" />
          </div>
          <div className="mailCheck-wrapper_note_text">
            <div className="mailCheck-wrapper_note_text_title">
              {MailCheckConstants.mailACheckPage.noteTitle}
            </div>
            <p className="mailCheck-wrapper_note_text_desc">
              {MailCheckConstants.mailACheckPage.noteDesc}
            </p>
          </div>
        </div>
      </div>
      <SSJBeaconButton
        id="mailCheckCtnBtn"
        label="Continue"
        variant="primary"
        scale="jumbo"
        iconAlign="right"
        onClick={handleContinueBtn}
        disabled={customerWebViewEnabled}
      >
        <img
          slot="icon"
          alt="Continue Button"
          className="continue-arrow-icon"
          src={continueIcon}
        />
      </SSJBeaconButton>

      <SSJBeaconModal
        id="downloadInvesTryAgian"
        scale="normal"
        elevation="3"
        closeonclickout=""
      >
        <p className="beacon-modal__title">Something went wrong</p>
        <p className="beacon-modal__description">
          {`There was an issue generating your investment slip but your information is not lost. Please try again. If the problem persists, you can call a service specialist at (855) 793-6611.`}
        </p>
        <div className="download-invest-try-again">
          <div className="download-invest-try-again_container">
            <SSJBeaconButton
              id="saveButton"
              type="button"
              variant="tertiary"
              onClick={() => handleModalClick('Cancel')}
              label="Cancel"
            />
            <SSJBeaconButton
              id="exitButton"
              type="button"
              variant="negative"
              onClick={downloadCheck}
              label="Try again"
            />
          </div>
        </div>
      </SSJBeaconModal>
    </div>
  );
};
export default MailACheckPage;
